/**
 * Free shipping progress bar.
 *
 * Keeps every [data-free-shipping-bar] instance (cart page + cart drawer) in
 * sync with the cart. The theme updates the cart over the Ajax API without
 * firing an event, so cart requests are observed on both fetch and
 * XMLHttpRequest and the bar re-renders from the response.
 */
(function () {
  'use strict';

  if (window.freeShippingBarLoaded) return;
  window.freeShippingBarLoaded = true;

  var PLACEHOLDER = '[[amount]]';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_STATE = /\/cart\.js(\?|$)/;

  function bars() {
    return document.querySelectorAll('[data-free-shipping-bar]');
  }

  /* Mirrors the theme's own money formatting (assets/theme.min.js). */
  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;

    function withDelimiters(number, decimals, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      var parts = (number / 100).toFixed(decimals).split('.');
      return (
        parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) +
        (parts[1] ? decimal + parts[1] : '')
      );
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return format.replace(placeholder, function () {
      return value;
    });
  }

  function render(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    Array.prototype.forEach.call(bars(), function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold || threshold <= 0) return;

      var total = cart.total_price;
      var remaining = Math.max(threshold - total, 0);
      /* Floored to match the Liquid-rendered value on first paint. */
      var percent = Math.min(100, Math.floor((total * 100) / threshold));

      bar.hidden = cart.item_count === 0;

      if (remaining === 0) {
        bar.classList.add('free-shipping-bar--complete');
      } else {
        bar.classList.remove('free-shipping-bar--complete');
      }

      var fill = bar.querySelector('[data-fsb-fill]');
      if (fill) fill.style.width = percent + '%';

      var track = bar.querySelector('[data-fsb-progress]');
      if (track) track.setAttribute('aria-valuenow', percent);

      var text = bar.querySelector('[data-fsb-text]');
      if (!text) return;

      if (remaining === 0) {
        text.textContent = bar.getAttribute('data-success-text') || '';
      } else {
        var money = formatMoney(remaining, bar.getAttribute('data-money-format') || '{{amount}}');
        var template = bar.getAttribute('data-progress-template') || '';
        text.innerHTML = template
          .split(PLACEHOLDER)
          .join('<span class="free-shipping-bar__amount">' + money + '</span>');
      }
    });
  }

  var refreshing = false;

  function refresh() {
    if (refreshing || !window.fetch) return;
    refreshing = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    nativeFetch
      .call(window, root.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(render)
      .catch(function () {})
      .then(function () {
        refreshing = false;
      });
  }

  /* /cart/add.js answers with the added line items, not the cart, so fall
     back to a cart lookup whenever the payload isn't a full cart. */
  function handlePayload(data) {
    if (data && typeof data.total_price === 'number' && data.items) {
      render(data);
    } else {
      refresh();
    }
  }

  function isCartRequest(url) {
    return CART_MUTATION.test(url) || CART_STATE.test(url);
  }

  var nativeFetch = window.fetch;

  if (nativeFetch) {
    window.fetch = function () {
      var request = nativeFetch.apply(this, arguments);

      try {
        var input = arguments[0];
        var url = String((input && input.url) || input || '');

        if (isCartRequest(url)) {
          request
            .then(function (response) {
              if (!response || !response.ok) return;
              response
                .clone()
                .json()
                .then(handlePayload)
                .catch(function () {});
            })
            .catch(function () {});
        }
      } catch (e) {}

      return request;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.freeShippingBarUrl = String(url || '');
    } catch (e) {}
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;

    if (xhr.freeShippingBarUrl && isCartRequest(xhr.freeShippingBarUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;

        var data = null;
        try {
          data =
            xhr.response && typeof xhr.response === 'object'
              ? xhr.response
              : JSON.parse(xhr.responseText);
        } catch (e) {}

        handlePayload(data);
      });
    }

    return nativeSend.apply(this, arguments);
  };

  function init() {
    var initial = document.getElementById('initial-cart');
    if (!initial) return;

    try {
      render(JSON.parse(initial.textContent));
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
